module.exports = __webpack_public_path__ + "static/case-hp-05-fc6453aa269159181d1de1682855086c.jpg";